import React, { useEffect, useState } from "react";
import { IoIosAddCircleOutline } from "react-icons/io";
import { FaSearch } from "react-icons/fa";
import { LuFileEdit } from "react-icons/lu";
import { FaRegTrashCan } from "react-icons/fa6";
import { ImCross } from "react-icons/im";
import Pagination from "../../utils/Pagination";
import { RiSortAlphabetAsc, RiSortAlphabetDesc } from "react-icons/ri";
import{createVillage,fetchVillages,fetchVillageById,updateVillage,deleteVillage,fetchPanchayats} from "../../services/api";
import AlertMsg from "../../components/AlertMsg/AlertMsg";
import Loading from "../../components/Loading/Loading";

const Village = () => {
  const [village, setVillages] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [blockToDelete, setBlockToDelete] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedPanchayatId, setSelectedPanchayatId] = useState("");
  const [panchayatOptions, setPanchayatOptions] = useState([]);
  const blocksPerPage = 10;
  const [sortAscending, setSortAscending] = useState(true);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    id:0,
    name: "",
    panchayatId:0,
    activeStatus: true,
  });
  const [formErrors, setFormErrors] = useState({
    id:0,
    name: "",
    panchayatId:"",
    activeStatus: "",
  });
  const validateForm = () => {
    let valid = true;
    let errors = {};

    if (!formData.name.trim()) {
      errors.name = "Village name is required.";
      valid = false;
    }

    if (!selectedPanchayatId) {
      errors.panchayatId = "Please select a Panchayat.";
      valid = false;
    }

    setFormErrors(errors);
    return valid;
  };
  const [alert, setAlert] = useState({ visible: false, message: '', type: '' });

    const fetchVillage = async () => {
      setLoading(true);
      try {
        const response = await fetchVillages();
        setVillages(response.data);
      } 
         catch (error) {
        console.error("Error fetching villages data:", error);
      }finally {
        setLoading(false);
      }
    };

    const fetchPanchayat = async () => {
      try {
        const response = await fetchPanchayats();
        setPanchayatOptions(response.data);
      } catch (error) {
        console.error("Error fetching panchayats data:", error);
      }
    };

    useEffect(() => {
    fetchVillage();
    fetchPanchayat();
  }, []);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const toggleEditModal = () => {
    setIsEditModalOpen(!isEditModalOpen);
    setFormData({ name: "", activeStatus: true });
    setFormErrors({ name: "", panchayat: "" });
    fetchVillage();
  };

  const toggleDeleteModal = () => {
    setIsDeleteModalOpen(!isDeleteModalOpen);
    setBlockToDelete(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const newValue = name === "activeStatus" ? value === "true" : value;
    setFormData({
      ...formData,
      [name]: newValue,
    });
    setFormErrors({
      ...formErrors,
      [name]: "",
    });
  };

  const handlePanchayatChange = (e) => {
    const selectedId = e.target.value;
    setSelectedPanchayatId(selectedId);
    setFormData((prevData) => ({
      ...prevData,
      panchayatId: selectedId, 
    }));
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(0);
  };
  
  const handleSortByName = () => {
    setSortAscending(!sortAscending); // Toggle sorting order
  };
  const filteredVillageStatus = village
    .filter(
      (block) =>
        block.name && block.name.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (sortAscending) {
        return a.name.localeCompare(b.name); // Ascending order
      } else {
        return b.name.localeCompare(a.name); // Descending order
      }
    });

  
  const pageCount = Math.ceil(filteredVillageStatus.length / blocksPerPage);

  const getCurrentPageBlocks = () => {
    const startIndex = currentPage * blocksPerPage;
    const endIndex = startIndex + blocksPerPage;
    return filteredVillageStatus.slice(startIndex, endIndex);
  };

  const handleCancel = () => {
    setFormData({
      id: 0,
      name: "",
      activeStatus: true,
    });
    setIsEditModalOpen(false);
    setIsModalOpen(false);
    setIsDeleteModalOpen(false);
    setBlockToDelete(null);
  };
   

  const handleAddBlock = async () => {
     if (!validateForm()) {
      return;
    }
    setIsModalOpen(false);
    setLoading(true);
    try {
      const response = await createVillage(formData);
      console.log(response.data);
      handleCancel();
      setAlert({ visible: true, message: 'Village added successfully!', type: 'success' });
      fetchVillage();
     }
      catch (error) {
      console.error("Error adding villages:", error);
      setAlert({ visible: true, message: 'Error adding village. Please try again.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleEditBlock = async (id) => {
    try {
      const response = await fetchVillageById(id);
      const villageData = response.data;
      
      setFormData(villageData); 
      setSelectedPanchayatId(villageData.panchayatId); 
      setIsEditModalOpen(true);
    } catch (error) {
      console.error("Error fetching village details:", error);
    }
  };
  

  console.log(formData);

  const handleSaveEditBlock = async () => {
    if (!validateForm()) {
      return;
    }
    setIsEditModalOpen(false);
    setLoading(true);
    try {
      const response = await updateVillage(formData.id,formData)
      console.log(response.data);
     
      handleCancel();
      setAlert({ visible: true, message: 'Village updated successfully!', type: 'success' });
      fetchVillage();

    } catch (error) {
      console.error("Error updating village:", error);
      setAlert({ visible: true, message: 'Error adding village. Please try again.', type: 'error' });
    }finally {
      setLoading(false);
    }
  };

  const handleDeleteBlock = async () => {
    if (!blockToDelete) return;
    setIsDeleteModalOpen(false);
    setLoading(true);
    try {
      await deleteVillage(blockToDelete.id);
      handleCancel();
      setAlert({ visible: true, message: 'village deleted successfully!', type: 'success' });
      fetchVillage();

    } catch (error) {
      console.error("Error deleting village:", error);
      setAlert({ visible: true, message: 'Error deleting village. Please try again.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteIconClick = (block) => {
    setBlockToDelete(block);
    setIsDeleteModalOpen(true);
  };


  return (
    <div className="houseState">
      {loading && <Loading/>}
      {!loading && (
      <div className="houseState-container box-shadow">
      {alert.visible && (
            <AlertMsg
              message={alert.message}
              type={alert.type}
              onClose={() => setAlert({ ...alert, visible: false })}
            />
          )}
        <div className="container-head p-15">
          <h2>Villages</h2>
          <div className="btns">
            <span className="add-btn" onClick={toggleModal}>
              <IoIosAddCircleOutline />
              <p>Add Village</p>
            </span>
          </div>
        </div>
        <div className="table-filters">
          <div className="search-filter">
            <label htmlFor="searchName">
              <FaSearch />
            </label>
            <input
              type="text"
              id="searchName"
              placeholder="Search by Villages"
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
        </div>
        <div className="houseState-content" style={{ overflowX: "auto" }}>
          <div className="table-container">
            <table className="custom-table">
              <thead>
                <tr>
                <th onClick={handleSortByName} style={{ cursor: 'pointer' }}>
  Village  {sortAscending ? <RiSortAlphabetAsc /> : <RiSortAlphabetDesc />}
</th>
                  <th>Panchayat</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {getCurrentPageBlocks().length > 0 ? (
                  getCurrentPageBlocks().map((item) => (
                    <tr key={item.id}>
                      <td className="text-left">{item.name}</td>
                      <td className="text-left"> {
                      panchayatOptions.find(
                        (panchayat) => panchayat.id === item.panchayatId
                      )?.name 
                    }</td>
                      <td className="text-center">
                        <p className={
                            item.activeStatus ? "active" : "inactive"
                          }>{item.activeStatus ? "Active" : "Inactive"}</p>
                      </td>
                      <td className="text-center">
                        <div className="action-btn">
      
                          <span
                            className="btn edit-btn"
                            onClick={() => handleEditBlock(item.id)}
                          >
                            <LuFileEdit />
                          </span>
                          <span
                            className="btn delete-btn"
                            onClick={() => handleDeleteIconClick(item)}
                          >
                            <FaRegTrashCan />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center">
                      No village status found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <Pagination
              pageCount={pageCount}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
            </div>
           
        </div>
      </div>
      )}

      {/* Add Village Modal */}
      {isModalOpen && (
        <div className="screen">
          <div className="screen-container">
            <div className="add-form-head">
              <h3>Add Village</h3>
              <span className="close-icon" onClick={toggleModal}>
                <ImCross />
              </span>
            </div>
            <div className="add-forms">
              <div className="add-form">
                <label htmlFor="name">Village Name</label>
                <input
                  type="text"
                  name="name"
                  placeholder="Enter village Name"
                  value={formData.name}
                  onChange={handleInputChange}
                />
              </div>

              <div className="add-form">
                <label htmlFor="panchayatName">Panchayat Name</label>
                <select
                  value={selectedPanchayatId}
                  onChange={handlePanchayatChange}
                >
                  <option value="">Select Panchayat</option>
                  {panchayatOptions.map((panchayat) => (
                    <option key={panchayat.id} value={panchayat.id}>
                      {panchayat.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="btn-container">
                <div className="addforbtns">
                  <div className="btn-cancel" onClick={toggleModal}>
                    Cancel
                  </div>
                  <button
                    className="btn"
                    onClick={handleAddBlock}
                    disabled={isLoading}
                  >
                    {isLoading ? "Loading..." : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}


      {/* Edit Village Modal */}
      {isEditModalOpen && (
        <div className="screen">
          <div className="screen-container">
            <div className="add-form-head">
              <h3>Edit Village</h3>
              <span className="close-icon" onClick={toggleEditModal}>
                <ImCross />
              </span>
            </div>
            <div className="add-forms">
              <div className="add-form">
                <label htmlFor="name">Village Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Enter Village Name"
                  className={formErrors.name ? "input-error" : ""}
                />
              </div>


              <div className="add-form">
                <label htmlFor="panchayatName">Panchayat Name</label>
                <select
  name="panchayatName"
  value={selectedPanchayatId}
  onChange={handlePanchayatChange}
  className={formErrors.selectedPanchayatId ? "input-error" : ""}
>
  <option value="" disabled>Select Panchayat Name</option>
  {panchayatOptions.map((option) => (
    <option key={option.id} value={option.id}>
      {option.name}
    </option>
  ))}
</select>

              </div>
              
              <div className="add-form">
                <label htmlFor="activeStatus">Active Status:</label>
                <div className="custom-radio-group">
                  <label className="custom-radio-label">
                    <input
                      type="radio"
                      name="activeStatus"
                      value={true}
                      checked={formData.activeStatus === true}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                    />
                    Active
                  </label>
                  <label className="custom-radio-label">
                    <input
                      type="radio"
                      name="activeStatus"
                      value={false}
                      checked={formData.activeStatus === false}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                    />
                    Inactive
                  </label>
                </div>
              </div>

              <div className="btn-container">
                <div className="addforbtns">
                  <div className="btn-cancel" onClick={toggleEditModal}>
                    Cancel
                  </div>
                  <button
                    className="btn"
                    onClick={handleSaveEditBlock}
                    disabled={isLoading}
                  >
                    {isLoading ? "Loading..." : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Delete Modal */}
      {isDeleteModalOpen && blockToDelete && (
        <div className="screen">
          <div className="screen-container delete-popup">
          <h2>Are you sure you want to delete?</h2>
          <p>This action is permanent and cannot be undone.</p>

            <button
              onClick={handleDeleteBlock}
              className="delete btn"
              disabled={isLoading}
            >
              {isLoading ? "Deleting..." : "Yes, Delete"}
            </button>
            <button className="btn-cancel" onClick={toggleDeleteModal}>
              No, Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Village;

